import parse from 'html-react-parser';
import _ from 'lodash';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import PageError from 'pages/404';
import { useState } from 'react';
import Layout from 'src/components/layouts';
import { APP_URL, SHOW_COMMEMORATE } from 'src/constants';
import { decryptionClient } from 'src/services/member-auth/utils/decryption-payload';
import { useDesktop } from 'src/utils/device';
import { timestamp } from 'src/utils/helper';
import { GET } from 'src/utils/services';
import useUser from 'src/utils/useUser';
import styled from 'styled-components';

const PrivacyPolicyPage = ({ privacyDataArray, dataAdsHeader }) => {
  const _data = useUser();
  const sessionSevId = _data?.user ? decryptionClient(_data?.user) : null;
  const [checkedState, setCheckedState] = useState([true, false, false]);
  const arrayName = ['นโยบายการใช้คุกกี้', 'ข้อกำหนดและเงื่อนไข', 'คำประกาศเกี่ยวกับความเป็นส่วนตัว'];
  function handleOnChange(position) {
    const newUpdate = [false, false, false];
    newUpdate[position] = true;
    setCheckedState(newUpdate);
  }
  const findIndex = _.findIndex(checkedState, e => e === true);

  if (_.isEmpty(privacyDataArray[0]) || _.isEmpty(privacyDataArray[1]) || _.isEmpty(privacyDataArray[2])) return <PageError dataAdsHeader={dataAdsHeader} />;
  // <div dangerouslySetInnerHTML={{ __html: privacyDataArray[index] }} /> // index is a policy no. //still in section tag
  return (
    <>
      <NextSeo
        noindex={true}
        nofollow={true}
        title='นโยบายความเป็นส่วนตัว'
        robotsProps={{
          maxImagePreview: 'large',
          maxSnippet: -1,
          maxVideoPreview: -1
        }}
      />
      <Head>
        <link rel='canonical' href={`${APP_URL}/privacy-policy`} />
        {/* ----------------------------- ScriptBrowser ------------------------------------ */}
        {!useDesktop() && !_.isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_mobile}`) : ''}
        {useDesktop() && !_.isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_desktop}`) : ''}
        {/* ----------------------------- ADS : PPN ------------------------------- */}
        <script async type='text/javascript' src='https://securepubads.g.doubleclick.net/tag/js/gpt.js' />
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: 'var googletag = googletag || {}; window.googletag.cmd = googletag.cmd || [];'
          }}
        />
        {/* --------------------------------- Truehit -------------------------------- */}
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: `
                __th_page="privacy-policy";
              `
          }}
        />
      </Head>
      <Layout sessionSevId={sessionSevId}>
        <div className='container' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : 'unset' }}>
          {!_.isEmpty(privacyDataArray[0]) &&
          privacyDataArray[0].data !== null &&
          !_.isEmpty(privacyDataArray[1]) &&
          privacyDataArray[1].data !== null &&
          !_.isEmpty(privacyDataArray[2]) &&
          privacyDataArray[2].data !== null ? (
            <SectionWrapper seq={findIndex} themeColor={'#0600E7'}>
              <div className='tab-link'>
                <div className='tab-button'>
                  {arrayName.map((item, index) => (
                    <li key={index}>
                      <label>
                        <input name='tab-control' onChange={() => handleOnChange(index)} type='checkbox' value={checkedState[index]} checked={checkedState[index] ? true : ''}></input>
                        <span>{`${item}`}</span>
                      </label>
                    </li>
                  ))}
                </div>
                <div className='indicator'></div>
              </div>
              <div className='content-container'>
                <div className={`policy ${findIndex === 0 ? 'open-0' : ''}`} dangerouslySetInnerHTML={{ __html: privacyDataArray[0] }} />
                <div className={`policy ${findIndex === 1 ? 'open-1' : ''}`} dangerouslySetInnerHTML={{ __html: privacyDataArray[1] }} />
                <div className={`policy ${findIndex === 2 ? 'open-2' : ''}`} dangerouslySetInnerHTML={{ __html: privacyDataArray[2] }} />
              </div>
            </SectionWrapper>) : ('ยังไม่ได้กำหนด privacy-policy')}
        </div>
      </Layout>
    </>
  );
};

const SectionWrapper = styled.div`
  position: relative;
  padding: 0.75rem 0;
  .tab-link {
    padding-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
    @media (max-width: 992px) {
      margin-top: 20px;
    }
  }
  .tab-button {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
    list-style-type: none;
    height: 50px;
    width: 100%;
    align-items: center;
    border-bottom: 4px solid #e3dede;
    @media (max-width: 475px) {
      padding-bottom: 70px;
    }
    li {
      box-sizing: border-box;
      flex: 1;
      width: 25%;
      padding: 0 10px;
      text-align: center;
      display: list-item;
      input:checked + span {
        color: ${props => props.themeColor};
      }
      label {
        white-space: initial;
        color: silver;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        cursor: pointer;
        transition: all 0.5s ease-in-out;
        font-weight: bold;
        font-size: 16px;
        width: 100%;
        @media (max-width: 992px) {
          font-size: 14px;
        }
        @media (max-width: 475px) {
          font-size: 14px;
        }
        &:hover {
          color: #585858;
        }
        input {
          display: none;
          transition: all 0.5s ease-in-out;
        }
      }
    }
  }

  /* .indicator {
    position: relative;
    width: calc(100% / 3);
    left: calc(calc(100% / 3) * ${props => props.seq});
    max-width: 100%;
    transition: all 0.33s ease-in-out;
    height: 4px;
    background: ${props => props.themeColor};
    border-radius: 1px;
    margin-top: -22px;
    top: 8px;
  } */

  .content-container {
    display: block;
    position: relative;
    margin-top: 30px;
    overflow-y: auto;
    height: auto;
    min-height: 500px;
    &::-webkit-scrollbar {
      width: 6px;
      background-color: #e3dede;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-track {
      background-color: #ffffff21;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: ${props => props.themeColor};
    }
    @media (max-width: 992px) {
      min-height: 600px;
      margin-top: 20px;
    }
    @media (max-width: 475px) {
      min-height: 300px;
      margin-top: 20px;
      margin-bottom: 0;
    }
    @media (max-width: 280px) {
      min-height: 370px;
    }
    .policy {
      position: absolute;
      top: 0;
      left: -250%;
      width: 100%;
      opacity: 0;
      overflow: hidden;
      transition: all 1.5s ease-in-out;
      &.open-0 {
        left: 0;
        opacity: 1;
        width: 100%;
      }
      &.open-1 {
        left: 0;
        opacity: 1;
        width: 100%;
      }
      &.open-2 {
        left: 0;
        opacity: 1;
        width: 100%;
      }
    }
  }
`;

export async function getServerSideProps() {
  const initProps = {
    statusCode: 200,
    errMessage: null,
    privacyDataArray: [],
    dataAdsHeader: null
  };
  async function getPolicyData() {
    try {
      const resDataI = await GET('/api/privacy-policy?policy=1');
      const resDataII = await GET('/api/privacy-policy?policy=2');
      const resDataIII = await GET('/api/privacy-policy?policy=3');
      const res = Promise.all([resDataI, resDataII, resDataIII]);
      const scriptBrowser = await GET('/api/headerAds');
      if (!_.isEmpty(scriptBrowser)) {
        initProps.dataAdsHeader = scriptBrowser || '';
      }

      const result = await res;
      return [result[0], result[1], result[2]];
    } catch (err) {
      console.error(`${timestamp()} ==========> PAGE_INDEX ERROR : `, err.message);
      initProps.errMessage = err.message;
      initProps.statusCode = err?.response?.status || 500;
    }
  }

  try {
    const privacyDataArray = await getPolicyData();
    if (!_.isEmpty(privacyDataArray)) initProps.privacyDataArray = privacyDataArray || [];
  } catch (err) {
    console.error(`${timestamp()} ==========> PAGE_INDEX ERROR : `, err.message);
    initProps.errMessage = err.message;
    initProps.statusCode = err?.response?.status || 500;
  }

  return {
    props: initProps
  };
}

export default PrivacyPolicyPage;
